export const feedback = {
  title: "Reclamações e Sugestões",
  subtitle: "Protocolo de Recolha e Gestão de Reclamações das Famílias",
  protocol: {
    title: "Protocolo de Gestão da Comunicação e Reclamações das Famílias",
    purpose: {
      title: "Propósito e Filosofia",
      points: [
        "Estabelecer um canal claro, organizado e eficaz para que as famílias possam expressar as suas preocupações, sugestões ou reclamações.",
        "Garantir que todas as comunicações sejam ouvidas e tratadas com a devida atenção e respeito.",
        "Proteger e apoiar a equipa de acompanhantes, atuando como filtro e facilitador na gestão das reclamações.",
        "Fomentar um ambiente de confiança, respeito e melhoria contínua na comunidade educativa."
      ]
    },
    scope: {
      title: "Aplicação",
      description: "Este protocolo aplica-se a todas as comunicações formais de reclamação ou preocupação apresentadas pelas famílias dos alunos da escola. Também é válido para recolher propostas de melhoria."
    }
  },
  contact: {
    title: "Canal Único de Receção",
    email: {
      title: "Comunicação por Email",
      description: "Todas as reclamações ou preocupações das famílias deverão ser dirigidas exclusivamente ao Diretor."
    },
    appointment: {
      title: "Marcação Prévia com a Direção",
      description: "Para aqueles casos que requeiram uma conversa presencial, serão atendidos sempre com marcação prévia combinada através de email.",
      note: "As famílias serão informadas sobre este protocolo e o canal único para assegurar o seu uso correto."
    }
  },
  process: {
    title: "Processo de Gestão da Reclamação",
    phases: [
      {
        title: "Fase 1: Receção e Filtro Inicial pela Direção",
        description: "O Diretor recebe a reclamação pelo canal estabelecido e realiza uma análise inicial.",
        steps: [
          "Num prazo máximo de 48 horas úteis, será enviado um aviso de receção à família.",
          "O Diretor realizará uma leitura e análise detalhada da reclamação.",
          "Será avaliada a clareza, relevância, gravidade/urgência, competência e contexto.",
          "Objetivo do filtro: Proteger a equipa de reclamações infundadas e priorizar as importantes."
        ]
      },
      {
        title: "Fase 2: Decisão e Encaminhamento pela Direção",
        description: "Baseado na análise inicial, o Diretor decidirá a ação a seguir:",
        steps: [
          "Resolução Direta pela Direção: Para reclamações menores ou mal-entendidos simples.",
          "Encaminhamento à Equipa (Filtrada e Gerida): Para reclamações que requerem intervenção do pessoal.",
          "Investigação ou reunião com ambas as partes: Para reclamações graves ou complexas.",
          "Reclamação Não Processável: Se a reclamação é infundada ou fora de competência."
        ]
      },
      {
        title: "Fase 3: Acompanhamento e Encerramento",
        description: "O Diretor supervisiona a evolução e comunica a resolução à família.",
        steps: [
          "Coordenação e acompanhamento interno das ações acordadas.",
          "Comunicação à família da resolução ou medidas adotadas.",
          "Procurar-se-á um encerramento satisfatório para todas as partes quando possível."
        ]
      }
    ]
  },
  guarantees: {
    title: "Confidencialidade e Respeito",
    points: [
      "Toda a informação relacionada com as reclamações será tratada com máxima confidencialidade.",
      "Será promovido um ambiente respeitoso em todas as comunicações.",
      "Manter-se-á um registo interno para identificar padrões e áreas de melhoria.",
      "Este protocolo será revisto anualmente para assegurar a sua eficácia."
    ]
  }
};